import { useState } from 'react';
import { useFeatureValue } from '@shared/core/featureFlags';

/** Keep the selected payout flow stable for an open dialog and defer the first Mercury mount. */
export const useTransferSheetRollout = (isOpen: boolean, canManagePayouts: boolean) => {
  const { value, loading } = useFeatureValue('activeCashFundPartner', { skip: !canManagePayouts });
  const eligible = canManagePayouts && !loading && value === 'mercury';
  const [session, setSession] = useState({ isOpen, enabled: eligible, hasOpenedMercury: isOpen && eligible });

  // Capture on the opening render, before children commit. Later flag responses apply next time.
  if (session.isOpen !== isOpen) {
    setSession({ isOpen, enabled: eligible, hasOpenedMercury: session.hasOpenedMercury || (isOpen && eligible) });
  }

  return {
    transferSheetEnabled: canManagePayouts && (isOpen ? session.enabled : eligible),
    // Keep it mounted after the first open so its close/reset lifecycle can finish.
    shouldMountTransferSheet: session.hasOpenedMercury,
  };
};
